'use client';

import { login, } from '@/web/auth/login/actions';
import TextBoxComponent from '@/components/text-box-component';
import ButtonComponent from '@/components/button-component';
import Image from 'next/image';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';


export default function LoginPage() {
  const searchParams = useSearchParams();
  const error = searchParams.get('error');
  const errorCode = searchParams.get('error_code');
  return (
    <div className="flex flex-col pt-24 w-96 mx-auto h-screen">
      <div className="flex justify-center pb-3">
        <Image src="/logo.png" alt="Numerology School" width={200} height={200} />
      </div>
      <h1 className="text-center text-2xl font-bold">Inicio sesión</h1>
      <form className="bg-white rounded-lg shadow-md p-5 mt-5">
        <div className="mb-5">
          <TextBoxComponent
            label="Email"
            id="email"
            name="email"
            placeholder="user@domain.ltd"
            required={true}
            type="email"
          />
        </div>
        <div className="mb-5">
          <TextBoxComponent
            label="Password"
            id="password"
            name="password"
            required={true}
            type="password"
          />
        </div>
        <div className="mb-5">
          {error && <p className="text-red-500">{error}</p>}
        </div>
        <div className="mb-5">
          {errorCode && <p className="text-red-500">El enlace de correo electrónico no es válido o ha caducado</p>}
        </div>
        <div className="mb-5">
          <ButtonComponent type="submit" label='Iniciar Sesión' formAction={login} wFull={true} />
        </div>
        <div className="mb-5 text-center text-gray-400 text-sm">
          <Link href="/auth/register">
            ¿No tienes cuenta? Regístrate
          </Link>
        </div>
      </form>
    </div>
  );
}
